<template>
  <ion-header class="ion-no-border header_app">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button color="medium" />
      </ion-buttons>
      <ion-title>{{ $route.meta.title || $store.state.app.name }}</ion-title>
      <ion-buttons slot="end">
        <ion-button
          v-if="$route.name != 'search'"
          @click="$router.push({ name: 'search' })"
        >
          <ion-icon slot="icon-only" icon="search" color="medium"></ion-icon>
        </ion-button>
        <ion-button @click="$router.push({ name: 'cart' })">
          <ion-icon
            slot="icon-only"
            ios="cart"
            md="cart"
            color="medium"
          ></ion-icon>
          <i
            v-show="$store.state.cart.items.length > 0"
            class="mdi mdi-checkbox-multiple-marked-circle mdi-18px cart-indicator"
          ></i>
        </ion-button>
        <ion-button
          v-if="$route.name != 'home'"
          @click="$router.push({ name: 'home' })"
          class="no-hover"
        >
          <ion-icon
            slot="icon-only"
            ios="home"
            md="home"
            color="medium"
          ></ion-icon>
        </ion-button>
        <ion-button @click="reload">
          <ion-icon
            slot="icon-only"
            ios="reload"
            md="reload"
            color="medium"
          ></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
</template>

<script>
export default {
  components: {},
  // eslint-disable-next-line no-unused-vars
  data: (vm) => ({}),
  computed: {},
  watch: {},
  beforeUnmount() {
    this.$emitter.off('change_nav_bg')
  },
  created() {},
  mounted() {},
  methods: {
    reload() {
      location.reload()
    }
  }
}
</script>

<style>
.no-hover {
  --background-hover: var(--background);
}
.md .cart-indicator {
  position: absolute;
  top: -0.2rem;
  right: -0.2rem;
  opacity: 0.9;
  color: greenyellow;
}
.ios .cart-indicator {
  position: absolute;
  top: 0.1rem;
  right: -0.2rem;
  opacity: 0.9;
  color: greenyellow;
}
</style>
